/**
 * @generated SignedSource<<d3df698183de8d303e195ea3ff1caebb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileScreenEmployeeEmployeeName_employee$data = {
  readonly assignedRoles: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly name: string;
  readonly " $fragmentType": "ProfileScreenEmployeeEmployeeName_employee";
};
export type ProfileScreenEmployeeEmployeeName_employee$key = {
  readonly " $data"?: ProfileScreenEmployeeEmployeeName_employee$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileScreenEmployeeEmployeeName_employee">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileScreenEmployeeEmployeeName_employee",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeRole",
      "kind": "LinkedField",
      "name": "assignedRoles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Employee",
  "abstractKey": null
};
})();

(node as any).hash = "32762f6d5bc1b75fb6abc94060fe12d1";

export default node;
